import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { task } from 'ember-concurrency';
import { APIGATEWAY } from 'lumen/utils/constants/general-constants';
import {
  DETAIL_VIEW_TABS,
  LAST_REFERENCE_PERIOD,
} from 'lumen/utils/constants/rate-strategy-constants';
import getAPIErrorMessage from 'lumen/utils/get-api-error-message';

export default class HotelStrategyDetailBaseRoute extends Route {
  queryParams = {
    sortBy: {
      refreshModel: false,
    },
    sortDirection: {
      refreshModel: false,
    },
    tab: {
      refreshModel: true,
    },
    subtype: {
      refreshModel: false,
    },
    entity: {
      refreshModel: false,
    },
    offset: {
      refreshModel: true,
    },
  };

  @service alerting;
  @service errorTracking;
  @service('hotel-and-market') hotelAndMarketService;
  @service intl;
  @service store;

  strategyEvolutionChartDataTask = task(
    { restartable: true },
    async (params) => {
      try {
        const apiParams = {
          namespace: APIGATEWAY,
          typeKey: 'ratestrategy',
          hotel_id: this.hotelAndMarketService.hotel?.id,
          compset_ids: '1,2', // Request both primary and secondary compset
          weeks: [0, -1, -2, -3, -4, -5, -6, -7].map(
            (week) => week - params.offset,
          ),
          // rstypes: [this.type] // Don't filter on rstype for now (to avoid collision with summary view IDs)
        };

        const ratestrategieshistoric = await this.store.query(
          'rate-strategy',
          apiParams,
        );
        return ratestrategieshistoric
          .filter(
            (ratestrategy) =>
              ratestrategy.extractDate !== LAST_REFERENCE_PERIOD,
          )
          .sort((a, b) => a.extractDate - b.extractDate);
      } catch (error) {
        if (error) {
          this.errorTracking.captureException(error);
        }

        this.alerting.showErrorAlert({
          text: getAPIErrorMessage(error, this.intl),
        });
      }
      return null;
    },
  );

  model(params) {
    if (params.tab === DETAIL_VIEW_TABS.GRAPH) {
      return {
        historicData: this.strategyEvolutionChartDataTask.perform(params),
        type: this.type,
      };
    }
    return {};
  }
}
